module.exports = "https://bin.bnbstatic.com/_next/static/images/icon.info-1704113d719129319309cc5727731a38.png";